import React, { useState } from "react";
import { MentionsInput, Mention } from "react-mentions";
import { Paper, Box, Typography } from "@mui/material";

const MentionInput = ({ memberList, tagsList, ticketStatus, setLocalReport, localReport, setReportLoaded }) => {
  const [text, setText] = useState(localReport.story);


  // Group members under "Member"
  const groupedUsers = {
    User: memberList.map((user) => ({ id: user.id, display: user.fullName })),
  };

  // Group tags under "Tags"
  const groupedTags = {
    Tags: tagsList.map((tag) => ({ id: tag.id, display: tag.value })),
  };


  const ticketStatusGrp = {
    status: ticketStatus.map((sts) => ({ id: sts.label, display: sts.label })),
  };

  // Merge both groups into one object
  const groupedData = { ...ticketStatusGrp, ...groupedTags, ...groupedUsers };

  // Convert grouped data to a flat list for react-mentions
  const mentionData = Object.entries(groupedData).flatMap(([group, items]) => [
    { id: `group-${group}`, display: group, isGroup: true }, // Group Header
    ...items.map((item) => ({ ...item, group })),
  ]);

  // Handle text change and extract mentions
  const handleChange = (event, newValue, newPlainTextValue, mentions) => {
    setText(newValue);

    let formattedText = newPlainTextValue;
    mentions.forEach((mention) => {
      console.log("mention", mention)
      // Find the correct mention object from mentionData to get the group
      const foundMention = mentionData.find((item) => item.id.toString() === mention.id.toString());
      const group = foundMention ? foundMention.group : "Unknown";

      const mentionFormat = `${group}='${mention.id}'`;
      formattedText = formattedText.replace(mention.display, mentionFormat);
    });
    setLocalReport((prev) => ({ ...prev, story: formattedText }));
    

  };

  return (
    <Box sx={{ display: "flex", width: "100%", alignItems: "flex-start", mt: 1 }}>
      <Paper sx={{ width: "100%", height: "200px", boxShadow: "none", fontSize: "14px" }}>
        <MentionsInput
          value={text}
          onChange={handleChange}
          style={{
            control: { fontSize: 14, width: "100%", minHeight: 200 },
            highlighter: { padding: 12, border: "none", outline: "none" },
            input: { padding: 12, border: "1px solid transparent" },
            suggestions: {
              list: {
                maxHeight: "300px",
                overflowY: "auto",
                backgroundColor: "white",
                border: "1px solid rgba(0,0,0,0.15)",
                borderRadius: "4px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                zIndex: 9999,
              },
              item: {
                padding: "5px 10px",
                cursor: "pointer",
                textAlign: "left",
                "&focused": { backgroundColor: "#1fa3c6", color: "white" },
              },
            },
          }}
          placeholder="Story example: I need a card list for last month's creations"
          maxLength={1000}
        >
          <Mention
            trigger="@"
            data={mentionData}
             onMouseOut={() => setReportLoaded(localReport)}
            renderSuggestion={(suggestion, search, highlightedDisplay, index) =>
              suggestion.isGroup ? (
                <Typography
                  key={index}
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    color: "GrayText",
                    borderRadius: "4px",
                    minWidth: "120px",
                    textAlign: "center",
                    outline: "none",
                  }}
                >
                  {suggestion.display}
                </Typography>
              ) : (
                <div
                  key={index}
                  style={{
                    padding: "5px 1px",
                    cursor: "pointer",
                    borderRadius: "6px",
                    fontSize: "11px",
                    minWidth: "120px",
                    textAlign: "left",
                    outline: "none",
                    boxShadow: "none",
                    border: "none",
                  }}
                >
                  {suggestion.display}
                </div>
              )
            }
          />
        </MentionsInput>
      </Paper>

    </Box>
  );
};

export default MentionInput;
